import React, { useState } from "react";
import Image from "next/image";
import Carousel from "@/components/ui/carousel/carousel";
import { SwiperSlide } from "swiper/react";
export default function Blueprints({ data = [] }) {
  const breakpoints = {
    1280: {
      slidesPerView: 2.4,
      spaceBetween: 30,
      slidesOffsetBefore: 32,
      slidesOffsetAfter: 32,
    },
    991: {
      slidesPerView: 2.2,
      spaceBetween: 20,
      slidesOffsetBefore: 32,
      slidesOffsetAfter: 32,
    },
    // when window width is >= 768px
    768: {
      slidesPerView: 1.4,
      spaceBetween: 20,
      slidesOffsetBefore: 32,
      slidesOffsetAfter: 32,
    },
    325: {
      slidesPerView: 1.15,
      spaceBetween: 10,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
    },
  };

  return (
    data?.length > 0 && (
      <div className="z-[100] relative w-full">
        <div className="flex flex-col w-full">
          <Carousel
            slidesPerView={2.4}
            spaceBetween={30}
            loop={true}
            className="featureCarousel w-full my-8"
            breakpoints={breakpoints}
            navigation={true}
            autoplay={{
              delay: 4500,
              disableOnInteraction: false,
            }}
            pagination={false}
            showNavAbove={true}
            // title={"Thoughtfully Designed at Chalk"}
            // description={
            //   "As modern interior designers in Gurgaon, we transform spaces into captivating environments that reflect your unique style. We follow a research-based process, allowing us to carefully assess all parts of the design before execution."
            // }

            // slidesOffsetAfter={20}
          >
            {data?.map((post, key) => (
              <SwiperSlide key={"Post" + key}>
                <Post data={post} />
              </SwiperSlide>
            ))}
          </Carousel>
        </div>
      </div>
    )
  );
}
const Post = ({ data }) => {
  return (
    <div className="w-full lg:h-[60vh] md:h-[483px] h-[320px] flex flex-col items-center justify-center relative">
      <Image
        src={data?.attributes?.url}
        alt="about banner"
        sizes="(max-width: 479px) 500px, 800px"
        fill
        className="w-full h-full object-cover"
      />
    </div>
  );
};
